<template>
  <div class="pdp-campaign-name">
    <div v-if="!isBnn" class="badge-container">
      <span class="label-l-semibold badge-new">
        ใหม่
      </span>
      <span class="label-l-semibold badge-pre-order">
        <template v-if="!isVip()">
          สั่งซื้อล่วงหน้า
        </template>
        <template v-else>
          ลงทะเบียนล่วงหน้า
        </template>
      </span>
    </div>

    <h1 class="display-s product-name">{{ campaignName }}</h1>

    <span v-if="!isVip()" class="label-info">
      รหัสสินค้า : {{ sku }}
    </span>
  </div>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  props: {
    campaignName: {
      type: String,
      default: '',
    },
    sku: {
      type: String,
      default: '',
    },
  },

  inject: ['isVip'],

  data() {
    return {
      isBnn,
    }
  },
}
</script>

<style lang="stylus" scoped>
.campaign-name-content{

}

.product-name {
    list-height 36.8px
    @media screen and (min-width: 1024px){
        line-height: 43px;
        margin: 4px 0
    }
}

.label-info {
    margin-right: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 10px;
    letter-spacing: 0.36px;
    color: rgba(18, 18, 18, 0.75);
    white-space: nowrap;

    @media screen and (max-width: 1024px){
        font-weight: 500;
        color: #6e6e73;
        font-size: .625rem;
        line-height: 1.6875rem;
    }
}

.badge-container {
    display: flex;
   gap: 8px;
}

.badge-new {
    color: #BF4800;
}
.badge-pre-order {
    color: #336e7b;
}

.-is-bnn
	.product-name
		font-size: 24px
		font-weight: bold
		line-height: 1.3
		margin: 0
	.label-info
		font-size: 12px
		line-height: 16px
		color: rgba(0, 0, 0, 0.45)
</style>
